import React, { useCallback, useEffect, useState } from "react";
import { Calendar, momentLocalizer } from 'react-big-calendar'
import "react-big-calendar/lib/css/react-big-calendar.css";

import { getParseDate, isStatusSucess } from "../../../../../../../helpers/helpers";
import moment from 'moment'
import { useLang } from "../../../../../../../language";
import { ModalDiaFestivo } from "./ModalDiaFestivo";
import { DiasFestivosServices } from "../../services/diasfestivos.service";
import { receiveFecha } from "../../../../../../../adapters/helpers";
import './index.scss'
import { LoaderFormCalendar } from "./LoaderFormParametro";

const localizer = momentLocalizer(moment)

require('moment/locale/ca.js')

export const DiasFestivos = () => {

    const Lang = useLang()

    const [events, setEvents] = useState<any>([])

    var currentDate = new Date();

    var theFirst = new Date(currentDate.getFullYear(), 0, 1);
    var theLast = new Date(currentDate.getFullYear(), 11, 31);

    const [defaultDate, setdefaultDate] = useState<any>('')

    const [fetchHorariosGET, fetchHorariosGETData] = DiasFestivosServices.POST_MOSTRAR_FECHAS()

    // ---------- GET  de eventos fechas

    useEffect(() => {

        if (isStatusSucess(fetchHorariosGETData.status)) {

            if (fetchHorariosGETData?.data?.items?.length > 0) {

                setEvents(fetchHorariosGETData?.data?.items?.map((item: any) => {

                    const fechTempStart = new Date(item.fecha + 'T00:00:00')
                    const fechTempEnd = new Date(item.fecha + 'T00:00:00')

                    return {
                        start: fechTempStart,
                        end: fechTempEnd,
                        title: item.descripcion,
                        // title: '',
                        // ideventofecha: item.ideventofecha,
                        fecha: receiveFecha(item.fecha),
                        // horainicio: item.horainicio,
                        // horafin: item.horafin,
                    }
                }))

                // setdefaultDate(new Date(fetchHorariosGETData?.data?.items?.[0]?.fecha))

            } else {

                // setdefaultDate(new Date())
            }
        }

    }, [fetchHorariosGETData])

    const handleSelectEvent = useCallback(

        ({ start, end, title }: any) => {

            const startinputdate = String(getParseDate(new Date(start)) || '')

            handleShowModal_Evento({
                start,
                end,
                startinputdate,
                descripcion: title,
                action: 'EDIT',
                fecha: startinputdate,
            })

        },
        [setEvents]
    )

    const handleSelectSlot = useCallback(

        ({ start, end, title }: any) => {

            const startinputdate = String(getParseDate(new Date(start)) || '')

            if (!events?.find((item: any) => item.fecha === startinputdate)) {

                handleShowModal_Evento({
                    start,
                    end,
                    startinputdate,
                    fecha: startinputdate,
                    action: 'CREATE',
                })
            }

        },
        [setEvents, events]
    )

    const lang = {
        ca: {
            week: 'Setmana',
            work_week: 'Setmana de treball',
            day: 'Dia',
            month: 'Mes',
            previous: '<',
            next: '>',
            today: 'Avui',
            agenda: 'El Diari',

            showMore: (total: any) => `+${total} més`,
        }
    }

    // ------------ Modal Horario Evento

    const [showModal_Evento, setShowModal_Evento] = useState<any>({
        value: false,
        payload: {}
    });

    const handleCloseModal_Evento = () => setShowModal_Evento({
        value: false,
        payload: {}
    });

    const handleShowModal_Evento = (payload: object) => setShowModal_Evento({
        value: true,
        payload
    });

    useEffect(() => {

        fetchHorariosGET({
            body: {
                fecha_desde: getParseDate(theFirst),
                fecha_hasta: getParseDate(theLast),
                limit: 100,
            }
        })

    }, [])


    return (
        <div>
            {
                fetchHorariosGETData.loading ?
                    <LoaderFormCalendar /> :
                    <>
                        <h5 className="mb-3">{Lang('DIAS_FESTIVOS')}</h5>
                        <Calendar
                            localizer={localizer}
                            events={events}
                            startAccessor="start"
                            endAccessor="end"
                            style={{ height: 500 }}
                            onSelectEvent={handleSelectEvent}
                            onSelectSlot={handleSelectSlot}
                            // defaultDate={defaultDate}
                            messages={lang['ca']}
                            views={
                                {
                                    month: true
                                }
                            }
                            culture={'ca'}
                            selectable
                        />

                        <ModalDiaFestivo
                            showModal_Evento={showModal_Evento}
                            handleCloseModal_Evento={handleCloseModal_Evento}
                            handleShowModal_Evento={handleShowModal_Evento}
                            fetchSuccess={fetchHorariosGET}
                            setEvents={setEvents}
                            events={events}
                        />
                    </>
            }
        </div>
    )
};
